import { render, staticRenderFns } from "./FreestylerView.vue?vue&type=template&id=5fc9fd22&scoped=true"
import script from "./FreestylerView.vue?vue&type=script&lang=js"
export * from "./FreestylerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc9fd22",
  null
  
)

export default component.exports